<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getConectores"]),
    totalProductos() {
      let total = 0;
      this.getConectores.forEach(item => {
        total = total + item.total;
      });
      return total;
    },
    totalTime() {
      let total = 0;
      this.getConectores.forEach(item => {
        total = total + item.time;
      });
      return total;
    }
  }
};
</script>

<template>
  <div class="panel panel-default" id="proveedores">
    <div class="panel-heading">Proveedores</div>
    <table class="table table-hover table-condensed table-striped">
      <tbody>
        <tr class="info">
          <th>ID</th>
          <th>Nombre</th>
          <th>Total</th>
          <th>Seg</th>
          <th></th>
        </tr>

        <tr v-for="proveedor in getConectores" :key="proveedor.id">
          <th v-text="proveedor.id" :title="proveedor.nombre"></th>
          <td v-text="proveedor.nombre" class="small"></td>
          <td v-text="proveedor.total"></td>
          <td v-text="proveedor.time"></td>
          <td class="text-right">
            <a :href="proveedor.url" target="_blank" v-if="proveedor.url">
              <i class="fa fa-external-link"></i>
            </a>
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr class="small warning">
          <th colspan="2">Totales</th>
          <th v-text="totalProductos"></th>
          <th v-text="totalTime"></th>
          <th></th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<style lang="scss" scoped>
#proveedores {
  border: 0;
  position: relative;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);

  > .panel-heading {
    color: #333;
    border: 0;
    padding: 10px 27px 10px 10px;
    position: relative;
    font-size: 14px;
    font-style: normal;
    background: #ccd1d9;
    font-weight: 600;
    text-align: center;
  }
  > .table > tbody {
    font-family: monospace;
    > tr {
      > th {
      }
      > td {
      }
    }
  }
}
</style>